import { colonyAPI } from '@/api';
import * as types from './mutation-types';

export default {
  getStaffAlerts({ commit }) {
    commit(types.GET_STAFF_ALERTS_REQUEST);

    colonyAPI
      .get('staff-alerts/')
      .then(resp => commit(types.GET_STAFF_ALERTS_SUCCESS, resp))
      .catch(error => commit(types.GET_STAFF_ALERTS_FAILURE, error));
  },

  updateStaffAlertAsRead({ commit }, id) {
    commit(types.UPDATE_STAFF_ALERT_REQUEST);

    colonyAPI
      .put(`staff-alerts/${id}/`, { read: true })
      .then(resp => commit(types.UPDATE_STAFF_ALERT_SUCCESS, resp))
      .catch(error => commit(types.UPDATE_STAFF_ALERT_FAILURE, error));
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/alerts/actions.js